<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 29.333c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334zm-3.626-18.374a1 1 0 00-1.414 1.414L14.586 16l-3.626 3.627a1 1 0 001.414 1.414L16 17.414l3.627 3.626a1 1 0 001.414-1.414l-3.627-3.627 3.627-3.626a1 1 0 00-1.414-1.414L16 14.585l-3.626-3.626z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsCircleCloseFilled'
}
</script>
